import styled               from 'styled-components';

import { ButtonVariants   } from 'src/components/common/button';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors,
         cssFlexRow       } from 'src/providers/theme/shared';



type ClearDataAcceptDialogLookAndFeel = {
  paddings: number[];

  captionTypo: Typo;
  captionColor: string;

  warningTypo: Typo;
  warningColor: string;

  gap: number;
  actionsGap: number;

  cancelButtonVariant: ButtonVariants;
  acceptButtonVariant: ButtonVariants;
}

const cleardataacceptdialog_light: ClearDataAcceptDialogLookAndFeel = {
  paddings: [28, 20],

  captionTypo: themeTypos.GRTSKREG_W600_S18_LH24,
  captionColor: themeColors.AccentBlue2,

  warningTypo: themeTypos.GRTSKREG_W400_S16_LH24,
  warningColor: themeColors.AccentRed1,

  gap: 20,
  actionsGap: 16,

  cancelButtonVariant: 'h48blueoutline',
  acceptButtonVariant: 'h48bluefill',
}

export type ClearDataAcceptDialogVariants = 'light';

export const cleardataacceptdialog_variants: Map<ClearDataAcceptDialogVariants, ClearDataAcceptDialogLookAndFeel> = 
  new Map<ClearDataAcceptDialogVariants, ClearDataAcceptDialogLookAndFeel>([
    ['light', cleardataacceptdialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: ClearDataAcceptDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;

  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;
`

export const Caption = styled.div<{
  lookAndFeel: ClearDataAcceptDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Warning = styled.div<{
  lookAndFeel: ClearDataAcceptDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.warningTypo)};
  color: ${(args) => args.lookAndFeel.warningColor};
`

export const Actions = styled.div<{
  lookAndFeel: ClearDataAcceptDialogLookAndFeel
}>`
  ${cssFlexRow};
  gap: ${(args) => args.lookAndFeel.actionsGap}px;
`